import { useAppSelector } from 'presentation/config/hooks/useRedux';
import { Card, CardBody } from 'reactstrap';

import ProfilePhoto from '../photoFile';

export const ContainerInfoProfile = () => {
  // hooks
  const { profileList } = useAppSelector((state) => state.Profile);

  // const
  const classPhoto =
    'rounded-circle avatar-xl img-thumbnail user-profile-image';

  return (
    <Card
      className="text-center"
      style={{
        height: '300px',
      }}
    >
      <CardBody className="p-4 d-flex justify-content-center align-items-center">
        <div className="text-center">
          <div className="profile-user position-relative d-inline-block mx-auto  mb-4">
            {/* <div className="d-flex align-items-center">
              {!profileList?.photo ? (
                <img src={profileList?.photo} className={`${classPhoto}`} />
              ) : (
                <div
                  style={{ background: '#144c5b' }}
                  className={`${classPhoto} justify-content-center align-content-center`}
                >
                  <span className="fs-3 text-light">
                    {getInitialsName(profileList?.name || '')}
                  </span> 
                </div>
              )}
            </div> */}
            <ProfilePhoto
              name={profileList?.name}
              photo={profileList?.photo}
              classPhoto={`${classPhoto} justify-content-center align-content-center`}
            />
          </div>
          <div>
            <h5 className="mb-1">{profileList?.name}</h5>
            <p className="text-muted mb-1">{profileList?.email}</p>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
